import { ModelBase } from "@shoothill/core";
import { IObservableArray, makeObservable, observable } from "mobx";
import { Validator } from "Application/Validation";
import { StudentSessionBehaviourModel } from "../StudentSessionBehaviour/StudentSessionBehaviourModel";

export class StudentBehaviourModel extends ModelBase<StudentBehaviourModel> {
    public studentId: string | null = null;
    public behaviourTypeId: string | null = null;
    //related
    public behaviourTypeName: string | null = null;
    public studentSessionBehaviour: StudentSessionBehaviourModel = new StudentSessionBehaviourModel();

    constructor() {
        super();
        makeObservable(this, {
            studentSessionBehaviour: observable,
        });
    }
}

export class StudentBehaviourModelValidator extends Validator<StudentBehaviourModel> {
    constructor() {
        super();
    }
}
